import React from "react";
import Photo from "./../../atoms/photo/index.jsx";

import "./styles.scss";

export default class VehicleGallery extends React.Component {
  render() {
    const vehicle = this.props.vehicle;

    //has Pictures
    var hasPictures = false;
    if (vehicle.images.length > 0) {
      hasPictures = true;
    }

    //title
    let title;
    if (hasPictures) {
      title = <h3>Fotos</h3>;
    } else {
      title = (
        <div className="noPhotos">
          <div className="noPhotosContainer">
            <h3>Sin fotos</h3>
            <p className="m">
              {" "}
              Lo sentimos, pero no tenemos fotos de este vehículo.
            </p>
            <p className="m">
              {" "}
              Llamános gratis al 0800 666 1033 o visítanos en nuestras oficinas,
              para saber más de este vehículo.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="vehicleGallery">
        <div className="container">
          <div className="title">{title}</div>
          <div className="gallery">
            {vehicle.images.map((image, i) => {
              return <Photo image={image} key={i} />;
            })}
          </div>
        </div>
      </div>
    );
  }
}
